import React from 'react'
import GenerateChallengeButton from './GenerateChallengeButton'

const MatchBot = require('../../../assets/svg/ai_svg.svg') as string

interface GenerateChallengeSectionProps {
	showIcon?: boolean
	center?: boolean
	btnBelowText?: boolean
}

const GenerateChallengeSection = (props: GenerateChallengeSectionProps) => {
	const { center = false, btnBelowText = false, showIcon = true } = props

	return (
		<>
			<div className="overflow-hidden shadow-sm p-2 rounded-md bg-white border items-center justify-center lg:justify-start flex-wrap border-b flex px-4">
				{showIcon && (
					<div className="w-32 px-2 md:mr-4 -ml-2 py-1">
						<MatchBot />{' '}
					</div>
				)}
				<div
					className={
						'flex flex-col flex-grow md:flex-grow-0 text-center items-center ' +
						(center ? 'mx-auto' : 'md:text-left md:items-start md:mr-6 ')
					}
				>
					<span className="text-gray-700 text-sm my-1">
						Need help or inspiration creating your challenge description?
					</span>
					<h3 className="font-semibold text-purple-800 text-lg my-1 md:my-0">
						Create your challenge description with AI
					</h3>
					{btnBelowText && (
						<div className={'my-3 ' + (center ? 'mx-auto' : '')}>
							<GenerateChallengeButton />
						</div>
					)}
				</div>
				{!btnBelowText && (
					<div className={'my-3 ' + (center ? 'mx-auto' : '')}>
						<GenerateChallengeButton />
					</div>
				)}
			</div>
		</>
	)
}

export default GenerateChallengeSection
